export default "__VITE_ASSET__DIPOm6ZO__"